import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import OneStepPayment from './one-step-payment';
import TwoStepPayment from './two-step-payment';
import { IPaymentProps } from './types';

const Payment: React.FC<IPaymentProps> = props => {
  const enableTwoStepCheckout = useFlag(LaunchDarklyFlag.TWO_STEP_CHECKOUT);

  if (enableTwoStepCheckout) {
    return <TwoStepPayment {...props} />;
  }
  return <OneStepPayment {...props} />;
};

export default Payment;
